import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, change } from 'redux-form';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { SelectField } from '..';
import messages from '../../../text/messages';
import options from '../../../text/selectOptions';

import './../fields.css';

class TimeField extends React.Component {
    componentDidMount() {
        const {
            changeField,
            input: { name, value },
            meta: { form }
        } = this.props;

        if (!value) {
            changeField(form, name, {
                hours: '08',
                minutes: '00',
                period: 'AM'
            });
        }
    }

    render() {
        const {
            input,
            placeholder,
            intl,
            hideErrors,
            meta: { error, warning },
            disabled
        } = this.props;

        let placeholderContent = typeof placeholder === 'string' ? placeholder : intl.formatMessage(placeholder);
        return (
            <div>
                <div className={`time-field ${disabled ? 'time-disabled-field' : ''}`}>
                    <div className="field-placeholder">{placeholderContent}</div>
                    <div className="time-column">
                        <div className="row">
                            <div className="time-colon">:</div>
                            <div className="col-xs-4">
                                <div className="row">
                                    <Field
                                        name={`${input.name}.hours`}
                                        component={SelectField}
                                        options={options.hours}
                                        placeholder={messages.hours}
                                        disabled={disabled}
                                    />
                                </div>
                            </div>
                            <div className="col-xs-4">
                                <div className="row">
                                    <Field
                                        name={`${input.name}.minutes`}
                                        component={SelectField}
                                        options={options.minutes}
                                        placeholder={messages.minutes}
                                        disabled={disabled}
                                    />
                                </div>
                            </div>
                            <div className="col-xs-4">
                                <div className="row time-period">
                                    <Field
                                        name={`${input.name}.period`}
                                        component={SelectField}
                                        options={options.timePeriods}
                                        placeholder={messages.period}
                                        disabled={disabled}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {hideErrors === undefined && <span className="validation-message">{error || warning}</span>}
            </div>
        );
    }
}

TimeField.defaultProps = {
    placeholder: '',
    meta: {},
    input: {}
};

TimeField.propTypes = {
    placeholder: PropTypes.any,
    meta: PropTypes.object,
    input: PropTypes.object
};

TimeField = injectIntl(TimeField);

const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            changeField: change
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TimeField);



// WEBPACK FOOTER //
// ./src/components/fields/time/index.jsx